module.exports = __webpack_public_path__ + "img/Summit_02@2x.81b65a18.jpg";